(function ($) {
    $.fn.deletingElementOnAction = function () {
        var $self = $(this);
        var $button = $self.find('.js-removable-button');
        var $form = $self.find('.js-removable-form');
        var URL = $form.attr('action');
        var method = $form.attr('method');
        var sendData;

        var init = function () {
            $button.on('click', function (event) {
                event.preventDefault();
                sendData = $form.serialize();
                $.ajax({
                    url: URL,
                    data: sendData,
                    type: method
                }).done(function (data) {
                    if (typeof data !== 'undefined' && typeof data.result !== 'undefined') {
                        if (data.result === 'success') {
                            $self.remove();
                        }
                    }
                });
            });
        };
        init();

    };
    $('.js-removable-item').each(function () {
        $(this).data('deletingElementOnAction', $(this).deletingElementOnAction());
    });
})(jQuery);
